import { useAuthSessionStore } from '../features/auth/session-store';
import { createApiClient, type ApiClient } from './api';
import type { ShellCommands } from './shell-commands';

export function createRuntimeApiClient(commands: ShellCommands): ApiClient {
  return createApiClient({
    getAccessToken: () => useAuthSessionStore.getState().accessToken,
    requestAccessToken: async () => {
      const token = await commands.requestAuthToken();
      useAuthSessionStore.getState().setAccessToken(token);
      return token;
    },
  });
}
